import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenObedience as ScreenObedienceFemale } from '../../../OwnAI/screens/Obedience';
import { ScreenObedience as ScreenObedienceMale } from '../../../OwnAIMan/screens/Obedience';
import { LayoutDataType } from '../../types';

export const ScreenObedience: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenObedienceMale />;
  }

  return <ScreenObedienceFemale />;
};
